import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.certificates.my.certificates': {
    id: 'profile.certificates.my.certificates',
    defaultMessage: 'My Certificates',
    description: 'A section of a user profile',
  },
  'profile.certificates.view.certificate': {
    id: 'profile.certificates.view.certificate',
    defaultMessage: 'View Certificate',
    description: 'A call to action to view a certificate',
  },
  'profile.certificates.types.verified': {
    id: 'profile.certificates.types.verified',
    defaultMessage: 'Verified Certificate',
    description: 'A type of certificate a user may have earned',
  },
  'profile.certificates.types.professional': {
    id: 'profile.certificates.types.professional',
    defaultMessage: 'Professional Certificate',
    description: 'A type of certificate a user may have earned',
  },
  'profile.certificates.types.unknown': {
    id: 'profile.certificates.types.unknown',
    defaultMessage: 'Certificate',
    description: 'The string to display when a certificate is of an unknown type',
  },
});

export default messages;
